import { css, cx, useTheme } from '@fable/theme'

interface Props {
  title: string
  subtitle?: string
  loaded: boolean
  simple: boolean
}

export const AudioPlayerInfo: React.VFC<Props> = ({
  title,
  subtitle,
  loaded,
  simple,
}) => {
  const { colors, motion } = useTheme()

  const styles = {
    info: css`
      margin-left: ${simple ? 12 : 8}px;
      max-width: 82%;
    `,
    infoText: css`
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.03em;
    `,
    title: css`
      margin-bottom: -2px;
      color: ${colors.blackSwan};
      font-weight: ${simple ? 400 : 600};
    `,
    subtitle: css`
      color: ${colors.hurricane};
      opacity: ${loaded ? 1 : 0};
      ${motion.transition('opacity')}
    `,
  }

  return (
    <div className={styles.info}>
      <p className={cx(styles.infoText, styles.title)}>
        {loaded ? title : 'Loading...'}
      </p>
      <p className={cx(styles.infoText, styles.subtitle)}>{subtitle}</p>
    </div>
  )
}
